import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';
import { AuthService } from '@app/core/services/auth/auth.service';

const publicApiUrls = [
  `${environment.api}/auth/token/`,
  `${environment.api}/auth/refresh/`,
  `${environment.api}/courts/`,
  new RegExp(`^${environment.api}/courts/\\d+/?$`),
  new RegExp(`^${environment.api}/geo/regions/[a-zA-Z]{2}/?$`),
  `${environment.api}/auth/register/`,
  new RegExp(`^${environment.api}/probates/invitations/.+$`),
  new RegExp(`^${environment.api}/guardians/invitations/.+$`),
  new RegExp(`^${environment.api}/auth/password-recovery/.+$`),
] as const;

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) {
  if (
    publicApiUrls.some((url) =>
      url instanceof RegExp ? url.test(req.url) : url === req.url,
    )
  ) {
    return next(req);
  }
  // Inject the current `AuthService` and use it to get an authentication token:
  const access = inject(AuthService).access();
  // Clone the request to add the authentication header.

  if (!access) {
    return next(req);
  }

  const newReq = req.clone({
    headers: req.headers.append('Authorization', `Bearer ${access}`),
  });
  return next(newReq);
}
